import * as Yup from 'yup';
import _isEmpty from 'lodash/isEmpty';

export const validationSchema = ({ t }) =>
  Yup.object().shape({
    name: Yup.string()
      .nullable()
      .required(t('Name is required')),
    externalId: Yup.string().nullable(),
    scac: Yup.string().nullable(),
    leadTimeWindow: Yup.number()
      .positive(t('Min. Lead Time is invalid'))
      .moreThan(0, t('Min. Lead Time is invalid'))
      .max(10000000, t('Min. Lead Time is invalid'))
      .decimals(1, t('Min. Lead Time is invalid')),
    ratingUrl: Yup.string()
      .nullable()
      .url(t('Rating URL is invalid')),
    ratingPhoneNumber: Yup.string()
      .nullable()
      .phone(t('Rating Phone Number is invalid')),
    dispatchUrl: Yup.string()
      .nullable()
      .url(t('Dispatch URL is invalid')),
    dispatchPhoneNumber: Yup.string()
      .nullable()
      .phone(t('Dispatch Phone Number is invalid')),
    customerServicePhoneNumber: Yup.string()
      .nullable()
      .phone(t('Dispatch Phone Number is invalid')),
    mcNumber: Yup.string().nullable(),
    dunsNumber: Yup.string().nullable(),
    usDotNumber: Yup.string().nullable(),
    federalEinNumber: Yup.string().nullable(),
    netTermsId: Yup.string()
      .nullable()
      .required(t('Net Terms is required')),
    p44AccountCode: Yup.string().nullable(),
    insuranceProvider: Yup.string().nullable(),
    insurancePolicyNumber: Yup.string().nullable(),
    insuranceEffectiveDate: Yup.string().nullable(),
    insuranceExpirationDate: Yup.string()
      .nullable()
      .when('insuranceEffectiveDate', {
        is: val => !_isEmpty(val),
        then: Yup.string()
          .required(t('Insurance Expiration Date is required'))
          .greaterThan(
            Yup.ref('insuranceEffectiveDate'),
            t(
              'Insurance Expiration Date must be greater than Insurance Effective Date'
            )
          )
      })
  });

export default validationSchema;
